import type { GQLShiftConflictsFragmentFragment } from 'codegen/gql-types';
import { Component, Prop } from 'vue-property-decorator';
import { Component as TsxComponent } from 'vue-tsx-support';

@Component
export default class RestrictedShiftPresets extends TsxComponent<{
  conflict: GQLShiftConflictsFragmentFragment;
}> {
  @Prop()
  public conflict: GQLShiftConflictsFragmentFragment;

  public render() {
    if (this.conflict.__typename !== 'RestrictedShiftPresetsConflict') {
      return null;
    }

    return (
      <span>
        {
          this.conflict.restrictedShiftPresets.join(', ')
        }
      </span>
    );
  }
}
